/*
 * 今日头条 - 热榜（服务端路由）
 */
export async function fetchToutiaoHot() {
  const res = await fetch('/server-api/toutiao')
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
